import { Component, input, model, output } from '@angular/core';
import { Params } from '@angular/router';
import { ButtonComponent } from '../button/button.component';
import { NotifyComponent } from '../notify/notify.component';
import { LinkTarget, State, States } from '@agilox/ui-common';

@Component({
	selector: 'ui-empty-state',
	imports: [ButtonComponent, NotifyComponent],
	templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent {
	image = input<string>('');
	imageStyles = input<string>('max-w-42.5 max-h-42.5 md:max-w-xs md:max-h-80');
	text = model<string>('');
	buttonText = input<string>('');
	buttonIcon = input<string>('');
	buttonRoute = input<string | string[] | undefined>(undefined);
	buttonQueryParams = input<Params | undefined>(undefined);
	buttonHref = input<string | undefined>(undefined);
	buttonTarget = input<LinkTarget | undefined>(undefined);
	isAbsolute = model<boolean>(false);
	notifyType = input<State | undefined>(States.Info);
	buttonClicked = output<Event>();

	clicked(event: Event) {
		this.buttonClicked.emit(event);
	}
}
